import React, { useState } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { Helmet } from "react-helmet-async";

const faqData = [
  {
    question:
      "Quels type de prestations proposez-vous en peinture d'interieure ?",
    answer:
      "Nous proposons des services de peinture intérieure, y compris la préparation des surfaces, l'application de peinture et les finitions.",
  },
  {
    question:
      "Intervenez-vous uniquement sur des chantiers de rénoivation ou aussi sur des projets neuf ?",
    answer:
      "Nous intervenons sur des projets de rénovation ainsi que sur des chantiers neufs.",
  },
  {
    question: "Quels type de peinture utilisez-vous ?",
    answer:
      "Nous utilisons principalement des peintures acryliques et des peintures à base de solvant, en fonction des besoins spécifiques de chaque projet. Nous proposons également des options écologiques et anti-humidité.",
  },
  {
    question: "Comment se passe un devis ? Est-ce gratuit ?",
    answer:
      "Nous proposons des devis gratuits et sans engagement. Il vous suffit de nous contacter pour discuter de votre projet, et nous vous fournirons un devis détaillé.",
  },
  {
    question: "Faut il vider la pièce avant votre intervention ?",
    answer:
      "Il est préférable de vider la pièce autant que possible pour faciliter notre travail. Cependant, nous pouvons également travailler avec des meubles en place si nécessaire.",
  },
  {
    question: "Combien de temps prend un chantier de peinture intérieure ?",
    answer:
      "La durée d'un chantier de peinture intérieure dépend de la taille du projet et des travaux nécessaires. En général, nous essayons de terminer les projets dans les meilleurs délais tout en garantissant une qualité optimale.",
  },
  {
    question: "Travaillez vous seul ou en équipe ?",
    answer:
      "Je travaille principalement seul afin de garantir un suivi rigoureux et une qualité constante sur chaque chantier. Pour certains projets de plus grande envergure, il peut toutefois m’arriver de faire appel à une équipe afin d’assurer le bon déroulement des travaux et de respecter les délais.",
  },
];

const Faq = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(index === openIndex ? null : index);
  };

  return (
    <div>
      <Helmet>
        <title>FAQ – Vos questions sur la peinture et nos services</title>
        <meta
          name="description"
          content="Trouvez les réponses aux questions fréquentes sur nos prestations, délais, produits utilisés et zones d’intervention autour de Vannes."
        />
        <link rel="canonical" href="https://lmcouleurs.fr" />
        <meta
          property="og:title"
          content="FAQ – Questions fréquentes sur nos services de peinture"
        />
        <meta
          property="og:description"
          content="Délai des travaux, produits utilisés, zone d’intervention… Retrouvez ici les réponses à vos questions."
        />
        <meta property="og:url" content="https://lmcouleurs.fr/faq" />
        <meta property="og:type" content="website" />
        <meta
          property="og:image"
          content="https://lmcouleurs.fr/images/og-faq.jpg"
        />
      </Helmet>

      <Navbar />
      <div className="faq">
        <h1>Des Questions ?</h1>
        <p>
          Chaque projet mérite toute mon attention. En tant qu'artisan peintre
          indépendant, je m'engage à vous offrir un accompagnement personnalisé
          à chaque étape de votre projet.
        </p>
        {faqData.map((item, index) => (
          <div key={index} className="faq-item">
            <button className="faq-question" onClick={() => toggleFAQ(index)}>
              {item.question}
              <span className="arrow">{openIndex === index ? "▲" : "▼"}</span>
            </button>
            <div className={`faq-answer ${openIndex === index ? "open" : ""}`}>
              {item.answer}
            </div>
          </div>
        ))}
      </div>
      <Footer />
    </div>
  );
};

export default Faq;
